import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const navigate = useNavigate();
    const location = useLocation(); // 获取当前路径

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    const user = {
        username: localStorage.getItem('username'),
        role: parseInt(localStorage.getItem('user_role'), 10), // 获取用户角色
    };

    return (
        <div className="navbar">
            <h2>铠大师智能体对话管理系统</h2>
            <div className="nav-links">
                <a
                    href="/dashboard"
                    className={location.pathname === '/dashboard' ? 'active' : ''}
                >
                    报表
                </a>
                <a
                    href="/rag_agent"
                    className={location.pathname === '/rag_agent' ? 'active' : ''}
                >
                    Ragflow-Agent
                </a>
                <a
                    href="/conversation"
                    className={location.pathname === '/conversation' ? 'active' : ''}
                >
                    聊天历史
                </a>
                <a
                    href="/review"
                    className={location.pathname === '/review' ? 'active' : ''}
                >
                    用户上报知识审核
                </a>
                <a
                    href="/data_sync"
                    className={location.pathname === '/data_sync' ? 'active' : ''}
                >
                    数据同步
                </a>
                <a
                    href="/settings"
                    className={location.pathname === '/settings' ? 'active' : ''}
                >
                    系统设置
                </a>
                {(user.role === 0 || user.role === 1) && (
                    <a
                        href="/user_management"
                        className={location.pathname === '/user_management' ? 'active' : ''}
                    >
                        用户管理
                    </a>
                    
                )}
                <a
                    href="/my_profile"
                    className={location.pathname === '/my_profile' ? 'active' : ''}
                >
                    我的
                </a>
            </div>
            <div className="user-info">
                <span>欢迎， {user.username}</span>
                <button onClick={handleLogout}>退出登录</button>
            </div>
        </div>
    );
}

export default Navbar;